import { i18n } from "services/i18nService";
import { PRIVATE_APP_ID } from "services/sosInventoryService/cart/schema";

import { initialErrorState } from "views/common";

function getAuthorizationField1ErrorMessage(record) {
  switch (record.connectionType) {
    case "Shopify":
      const isPrivate = record.shopifyAppType === "private";
      return isPrivate
        ? i18n("isValid.cart.ShopifyApiKey")
        : i18n("isValid.cart.AdminApiAccessToken");
    case "BigCommerce":
      return i18n("isValid.cart.BigCommerceClientId");
    default:
      break;
  }
}

export function isValid(record) {
  const errors = initialErrorState();

  const isPayPal = record?.connectionType === "PayPal";
  const isBigCommerce = record?.connectionType === "BigCommerce";
  const isShopify = record?.connectionType === "Shopify";

  if (!record.name || !record.name.trim().length) {
    errors.messages.push(i18n("isValid.Name"));
    errors.entity.push("name");
  }

  if (!record.location) {
    errors.messages.push(i18n("isValid.Location"));
    errors.entity.push("location");
  }

  if (!record.txnType) {
    errors.messages.push(i18n("isValid.cart.TxnType"));
    errors.entity.push("txnType");
  }

  if (!isPayPal && !record.authorizationField1) {
    errors.messages.push(getAuthorizationField1ErrorMessage(record));
    errors.entity.push("authorizationField1");
  }

  if (isBigCommerce && !record.storeIdentifier) {
    errors.messages.push(i18n("isValid.cart.BigCommerceApiPath"));
    errors.entity.push("storeIdentifier");
  }

  if (isShopify) {
    if (!record.storeIdentifier) {
      errors.messages.push(i18n("isValid.cart.Shop"));
      errors.entity.push("storeIdentifier");
    }

    if (
      record.shopifyAppType === PRIVATE_APP_ID &&
      !record.authorizationField2
    ) {
      errors.messages.push(i18n("isValid.cart.ShopifyApiPassword"));
      errors.entity.push("authorizationField2");
    }
  }

  return errors;
}
